<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title38">
<p class="p-c-br">This book is dedicated to ‘Our dear Channel Islands’ <br/>(Winston Churchill, 1945); to my husband, Mike, who <br/>introduced me to the Islands; and to Colin, whose <br/>name means so much in Guernsey.</p></a></div><a id="title38">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783408269_ded01.vue?69c897ca